<template>
    <b-modal v-model="imageModal" title="Image Upload">
        <b-container fluid>
            <b-form-file @change="uploadFile" ref="fileInput" v-model="file" accept="image/*"
                placeholder="Choose an image file" class="mt-3">
            </b-form-file>
        </b-container>
    </b-modal>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            file: null,
            key: null,
            fileName: null,
        }
    },

    computed: {
        imageModal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value) // Emit the Boolean value to control modal visibility
            },
        },
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
    },
    methods: {
        async uploadFile(event) {
            console.log('uploadFile event:', event.target.files)
            this.loaded = !this.loaded
            var fileName = event.target.files[0].name
            var fileExtension = fileName.split('.').pop()
            let maxFileSize = this.$maxFileSize

            if (maxFileSize < event.target.files[0].size) {
                return false
            }
            const img = new Image()
            this.uploadedObjectURL = URL.createObjectURL(event.target.files[0])
            img.src = this.uploadedObjectURL

            await this.$store.dispatch('js_report/fetchCredentials')
            await this.$nextTick()
            const { key, name } = await this.$store.dispatch(
                's3files/s3singleUpload',
                event.target.files
            )
            await this.$nextTick()
            const url = `${this.mediaBaseUrl}/${key}`
            this.$emit('set-image-url', url)
            this.imageModal = false
        },
    },
}
</script>

<style scoped></style>
